/* La Clé du 16 – clés sur numéro (refonte du 28/10/2026)
   1. Recherche d'une clé par son numéro (accueil, page « copie de clés », pages des marques).
   2. Fiche clé : type de clé (clé simple ou clé de passe), contrôle du numéro, carte de propriété (et nouvelle carte),
      fichiers, quantité et remise dégressive, validation.
   Le numéro saisi ne quitte jamais le navigateur avant l'ajout au panier : il n'est pas mis dans l'adresse de la
   page ; il est gardé le temps de la visite (sessionStorage) pour préremplir la fiche choisie. */
(function () {
  'use strict';
  if (window.__lck) return;
  window.__lck = 1;

  var I18N = {};
  try {
    var ij = document.querySelector('[data-lck-i18n]');
    if (ij) I18N = JSON.parse(ij.textContent || '{}');
  } catch (e) {}
  function T(k, rep) {
    var s = I18N[k] || '';
    if (rep) for (var p in rep) s = s.split('[' + p + ']').join(rep[p]);
    return s;
  }
  var LOC = (document.documentElement.lang || 'fr').slice(0, 2);

  function N(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }
  function H(s) {
    return String(s == null ? '' : s).replace(/[&<>'"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c];
    });
  }
  function money(c) {
    c = Math.round(+c || 0);
    var e = Math.floor(c / 100), r = c % 100, cs = r ? (r < 10 ? '0' : '') + r : '';
    function th(n, sep, min) {
      var s = String(n);
      if (n < min) return s;
      return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }
    if (LOC === 'en') return '€' + th(e, ',', 1000) + (cs ? '.' + cs : '');
    return th(e, ' ', LOC === 'es' ? 10000 : 1000) + (cs ? ',' + cs : '') + ' €';
  }
  function rootUrl(el) {
    var r = (el && el.getAttribute('data-root')) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.slice(-1) === '/' ? r : r + '/';
  }

  /* ---------- Données (chargées à la demande) ---------- */
  /* src : adresses des fichiers de données séparées par « | » (la 2e partie complète la 1re) */
  var dataP = null;
  function loadOne(u) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = u;
      s.async = false;
      s.onload = res;
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  function loadData(src) {
    if (window.LC16K && window.LC16K.done) return Promise.resolve(window.LC16K);
    if (dataP) return dataP;
    var parts = String(src || '').split('|').filter(Boolean);
    dataP = parts.reduce(function (p, u) { return p.then(function () { return loadOne(u); }); }, Promise.resolve())
      .then(function () {
        if (!window.LC16K) throw new Error('data');
        window.LC16K.done = 1;
        return window.LC16K;
      })
      .catch(function (e) { dataP = null; throw e; });
    return dataP;
  }
  /* Modèle : [poignée courte, marque, nom, type, suffixe, repères, formes, formats, pièces, délai, unité]
     Clés de passe (30/10/2026) : LC16K.v (lc16-cles-data-3.js) donne, pour chaque modèle dont la clé de passe est une
     variante de la fiche de la clé, l'identifiant de cette variante ; le lien mène alors à la fiche de la clé, type
     « clé de passe » choisi (?variant=…). */
  function passeVar(r) { var v = window.LC16K && window.LC16K.v; return (r[3] === 1 || r[3] === 0) && v && v[r[0]] || 0; }
  function handle(r) { return (r[3] === 1 && !passeVar(r) ? 'cle-de-passe-' : r[3] === 2 ? 'copie-de-cle-' : 'cle-') + r[0] + (r[4] ? '-sur-numero' : ''); }
  function href(root, r) { return root + 'products/' + encodeURIComponent(handle(r)) + (r[3] === 1 && passeVar(r) ? '?variant=' + passeVar(r) : ''); }
  /* Un seul résultat par fiche : la clé et la clé de passe d'un même modèle mènent à la même fiche. Avant le
     décompte des modèles, on garde la mieux notée des deux ; à égalité, la clé simple (le client choisit le type
     sur la fiche). La clé de passe n'est retenue que si le numéro la désigne (repère PP/PG, format propre). */
  function bestOfProduct(a) {
    var best = {};
    a.forEach(function (x) {
      if (!passeVar(x.r)) return;
      var k = x.r[0], y = best[k];
      if (!y) { best[k] = x; return; }
      /* format reconnu, puis qualité du format, puis repère (PP, PG…), puis clé simple ; le rang reste celui du meilleur */
      var xb = x.ruleHit !== y.ruleHit ? x.ruleHit : x.ruleQ !== y.ruleQ ? x.ruleQ > y.ruleQ : x.mark !== y.mark ? x.mark > y.mark : x.r[3] === 0;
      var s = Math.max(x.s, y.s);
      if (xb) best[k] = x;
      best[k].s = s;
    });
    return a.filter(function (x) { return !passeVar(x.r) || best[x.r[0]] === x; }).sort(byScore);
  }
  function oneByProduct(list) {
    var seen = {};
    return list.filter(function (x) {
      if (!passeVar(x.r)) return true;
      if (seen[x.r[0]]) return false;
      seen[x.r[0]] = 1;
      return true;
    });
  }

  /* ---------- Correspondance numéro → modèles (même logique que l'ancien outil de recherche) ---------- */
  function brandOf(K, r) { return K.b[r[1]] || ['', '']; }
  function modelOnly(K, r) {
    var w = String(r[2]).split(' '), b = N(brandOf(K, r)[0]);
    if (w.length > 1 && N(w[0]) === b) w.shift();
    else if (w.length > 2 && N(w[0] + w[1]) === b) w.splice(0, 2);
    else if (w.length > 2 && N(w[1]) === b) w.splice(0, 2);
    return w.join(' ');
  }
  function titleFr(r) { return (r[3] === 1 ? 'Clé de passe ' : r[3] === 2 ? 'Copie de clé ' : 'Clé ') + r[2]; }
  function shapes(q, s) {
    var L = (q.match(/[A-Z]/g) || []).length, d = (q.match(/[0-9]/g) || []).length;
    return (s ? s.split(',') : []).some(function (x) {
      var m = x.match(/^L(\d+)D(\d+)$/); if (m) return L === +m[1] && d === +m[2];
      m = x.match(/^D(\d+)L(\d+)$/); if (m) return d === +m[1] && L === +m[2];
      m = x.match(/^A(\d+)$/); if (m) return q.length === +m[1] && L && d;
      m = x.match(/^D(\d+)$/); return m && L === 0 && d === +m[1];
    });
  }
  function ruleQuality(rule) {
    var x = rule.replace(/\\d(?:\{[^}]+\}|[+*?])?/g, '').replace(/\[[^\]]+\](?:\{[^}]+\}|[+*?])?/g, '').replace(/[()?:]/g, '');
    var lit = Math.max.apply(null, [0].concat(x.split('|').map(function (v) { return N(v).length; })));
    var pen = (rule.match(/\[A-Z\](?:\{[^}]+\}|[+*?])?/g) || []).length * 6 + (rule.match(/\[A-Z0-9\](?:\{[^}]+\}|[+*?])?/g) || []).length * 8 +
      (rule.match(/\[A-Z0-9\][*+]/g) || []).length * 25 + (rule.match(/(?:\\d|\[0-9\])\+/g) || []).length * 12 + (rule.match(/\|/g) || []).length * 2;
    return lit * 25 - pen;
  }
  var RX = {};
  function rx(rule) {
    if (!(rule in RX)) { try { RX[rule] = new RegExp('^(?:' + rule + ')$'); } catch (e) { RX[rule] = null; } }
    return RX[rule];
  }
  function ruleHit(r, q) {
    var hit = false, best = -99;
    (r[7] ? r[7].split(';') : []).forEach(function (rule) {
      var re = rx(rule);
      if (re && re.test(q)) { hit = true; best = Math.max(best, ruleQuality(rule)); }
    });
    return { hit: hit, q: best };
  }
  function score(K, r, q, i) {
    var s = i < K.t ? 30 : 0, mark = 0, m = N(modelOnly(K, r)), t = N(titleFr(r));
    if (/^\d{6}C$/.test(q) && r[0] === 'heracles-y7c') s += 260;
    if (m === q) s += 230; else if (q.length > 2 && m.indexOf(q) > -1) s += 110;
    if (q.length > 2 && t.indexOf(q) > -1) s += 85;
    var rh = ruleHit(r, q);
    if (rh.hit) s += 420 + rh.q;
    (r[5] ? r[5].split(',') : []).forEach(function (x) {
      var z = N(x);
      if (!z) return;
      if (q === z) { s += z.length > 1 ? 260 : 35; if (z.length > 1) mark = Math.max(mark, 300 + z.length); }
      else if (q.indexOf(z) === 0) { s += z.length > 1 ? 230 + z.length : 25; if (z.length > 1) mark = Math.max(mark, 200 + z.length); }
      else if (z.length > 2 && q.indexOf(z) > -1) { s += 145 + z.length; mark = Math.max(mark, 100 + z.length); }
    });
    if (shapes(q, r[6])) s += 28;
    return { r: r, s: s, ruleHit: rh.hit, ruleQ: rh.q, mark: mark };
  }
  function byScore(a, b) { return b.s - a.s || (a.r[2] < b.r[2] ? -1 : 1); }
  /* Renvoie { list, top, status, help } */
  function match(K, raw, brand) {
    var q = N(raw);
    if (q.length < 2) return { list: [], status: T('st_short'), help: false, short: true };
    var M = K.m.map(function (r, i) { return [r, i]; });
    if (brand) M = M.filter(function (x) { return brandOf(K, x[0])[1] === brand; });
    if (['B2', 'B1', 'D4', 'C3', 'GS'].indexOf(q) > -1) {
      var rb = M.filter(function (x) { return /rb-locks|locxis/.test(x[0][0]); }).map(function (x) { return { r: x[0], s: 300 }; });
      if (rb.length) return { list: rb.slice(0, 12), status: T('st_rb'), help: true };
    }
    if (/^B[A-Z0-9]{2,7}A0[1-6][A-Z0-9]{1,5}$/.test(q)) {
      var sec = M.filter(function (x) { return /securystar/.test(x[0][0]); }).map(function (x) { return { r: x[0], s: 300 }; });
      if (sec.length) return { list: sec.slice(0, 12), status: T('st_sec'), help: true };
    }
    var a = bestOfProduct(M.map(function (x) { return score(K, x[0], q, x[1]); }).filter(function (x) { return x.s >= 28; }).sort(byScore));
    if (!a.length) return { list: [], status: T('st_none'), help: true, none: true };
    var marks = a.filter(function (x) { return x.mark > 0; });
    var maxMark = Math.max.apply(null, [0].concat(marks.map(function (x) { return x.mark; })));
    var bestMark = marks.filter(function (x) { return x.mark === maxMark; });
    var raw2 = a.filter(function (x) { return x.ruleHit; });
    var top = Math.max.apply(null, [-99].concat(raw2.map(function (x) { return x.ruleQ; })));
    var good = raw2.filter(function (x) { return x.ruleQ >= 25 && x.ruleQ >= top - 60; });
    var rules = (good.length ? good : top >= 0 ? raw2.filter(function (x) { return x.ruleQ === top; }) : []).sort(function (x, y) { return y.s - x.s || y.ruleQ - x.ruleQ; });
    var decisive = bestMark.length === 1 && ((bestMark[0].ruleHit && !raw2.some(function (y) { return y.r !== bestMark[0].r && y.ruleQ > 0; })) || !rules.length) ? bestMark[0] : null;
    if (!decisive && rules.length === 1) decisive = rules[0];
    if (decisive) {
      /* Autres modèles dont le format accepte aussi ce numéro (ex. IH + 6 chiffres : Deny Satyx et DOM iX Saturn) */
      var alt = raw2.filter(function (x) { return x.r !== decisive.r && x.ruleQ >= 0; });
      var others = (alt.length ? alt : (rules.length ? rules : a).filter(function (x) { return x.r !== decisive.r; })).slice(0, 3);
      return { list: [decisive].concat(others), top: decisive, status: T('st_one'), help: false };
    }
    if (rules.length > 1) return { list: rules.slice(0, 12), status: T('st_many', { n: Math.min(rules.length, 12) }), help: false };
    if (bestMark.length) return { list: bestMark.slice(0, 8), status: T('st_maybe'), help: true };
    return { list: a.slice(0, 8), status: /^\d+$/.test(q) ? T('st_digits') : T('st_maybe'), help: true };
  }

  /* ---------- Recherche par nom : marque et/ou modèle (« bricard s2 », « radialis », « clé de passe vachette ») ---------- */
  var STOP = ' CLE CLES CLEF CLEFS DE DU DES D LA LE LES L SUR NUMERO NUMEROS NUM NO POUR MA MON MES UNE UN DOUBLE DOUBLES COPIE COPIES REPRODUCTION REPRODUIRE REFAIRE COMMANDER CODE KEY KEYS COPY CUT TO BY NUMBER LLAVE LLAVES COPIA POR EL ';
  var PASSE = ' PASSE PASSES MASTER MAESTRA MAESTRAS ';
  var ALIAS = { FTH: 'fth-thirard', FTHTHIRARD: 'fth-thirard', SECURISTAR: 'securistar', MULTILOCK: 'mul-t-lock', MULTLOK: 'mul-t-lock', EUROLOCK: 'euro-locks', RBLOCK: 'rb-locks', VACHETE: 'vachette', BRICCARD: 'bricard', HERACLES: 'heracles' };
  function words(raw) {
    return String(raw || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean);
  }
  function isStop(w) { return STOP.indexOf(' ' + w + ' ') > -1; }
  function isPasse(w) { return PASSE.indexOf(' ' + w + ' ') > -1; }
  var BIX = null;
  function brandIndex(K) {
    if (BIX) return BIX;
    BIX = {};
    K.b.forEach(function (b, i) { if (b[1]) { BIX[N(b[0])] = i; BIX[N(b[1])] = i; } });
    for (var a in ALIAS) K.b.forEach(function (b, i) { if (b[1] === ALIAS[a]) BIX[a] = i; });
    return BIX;
  }
  /* Repère la marque écrite dans la recherche (un à trois mots : « mul t lock ») */
  function brandTokens(K, W) {
    var ix = brandIndex(K), used = {}, found = null;
    for (var i = 0; i < W.length; i++) {
      for (var len = Math.min(3, W.length - i); len >= 1; len--) {
        var j = W.slice(i, i + len).join('');
        if (ix[j] != null) { found = ix[j]; for (var x = i; x < i + len; x++) used[x] = 1; i += len - 1; break; }
      }
    }
    return { b: found, used: used };
  }
  /* Chaque mot cherché doit se retrouver dans le nom du modèle (mot exact, début de mot, ou partie du nom) */
  function nameScore(r, rest, bt, wantPasse) {
    if (bt.b != null && r[1] !== bt.b) return 0;
    var mw = words(r[2]), mj = mw.join(''), s = 0;
    for (var k = 0; k < rest.length; k++) {
      var w = rest[k], best = 0;
      for (var m = 0; m < mw.length; m++) {
        if (mw[m] === w) { best = 3; break; }
        if (w.length >= 2 && mw[m].indexOf(w) === 0) best = Math.max(best, 2);
      }
      if (!best && w.length >= 3 && mj.indexOf(w) > -1) best = 1;
      if (!best) return 0;
      s += best;
    }
    var sc = 500 + s * 40 + (bt.b != null ? 60 : 0) - Math.max(0, mw.length - rest.length - (bt.b != null ? 1 : 0)) * 6;
    if (wantPasse) sc += r[3] === 1 ? 80 : -80; else if (r[3] === 0) sc += 15;
    return sc;
  }
  /* Recherche complète : nom (marque, modèle) d'abord, puis numéro (formats et repères) */
  function find(K, raw, brand) {
    var W = words(raw), bt = brandTokens(K, W), wantPasse = W.some(isPasse);
    var rest = W.filter(function (w, i) { return !bt.used[i] && !isStop(w) && !isPasse(w); });
    if (brand && bt.b != null && K.b[bt.b][1] !== brand) bt = { b: bt.b, used: bt.used, other: true };
    var named = [];
    if (rest.length || bt.b != null) {
      K.m.forEach(function (r, i) {
        if (brand && !bt.other && brandOf(K, r)[1] !== brand) return;
        var s = nameScore(r, rest, bt, wantPasse);
        if (s) named.push({ r: r, s: s + (i < K.t ? 5 : 0), i: i });
      });
    }
    var bslug = bt.b != null ? K.b[bt.b][1] : '';
    if (!rest.length && bt.b == null && W.length) return { list: [], status: T('st_hint'), help: true, none: true };
    if (named.length) {
      var out = { help: false, brand: bt.b };
      if (!rest.length) {
        named.sort(function (a, b) { return (wantPasse ? (b.r[3] === 1) - (a.r[3] === 1) : (a.r[3] !== 0) - (b.r[3] !== 0)) || a.i - b.i; });
        out.list = named.slice(0, 8);
        out.status = T('st_brand', { b: K.b[bt.b][0] });
        out.count = named.length;
        return out;
      }
      named.sort(byScore);
      out.list = named.slice(0, 8);
      if (named.length === 1 || named[0].s - named[1].s >= 60) { out.top = named[0]; out.status = T('st_one'); }
      else out.status = T('st_name');
      return out;
    }
    if (bt.b != null && rest.length) return match(K, rest.join(''), bslug);
    if (bt.b != null) return match(K, raw, bslug);
    return match(K, raw, brand);
  }

  /* ---------- Fiches produits (prix, photo, titre et format dans la langue de la page) ---------- */
  var PJ = {};
  function productJson(root, h) {
    if (!PJ[h]) {
      PJ[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { delete PJ[h]; return null; });
    }
    return PJ[h];
  }
  var LAB = { fr: ['Reproduction', 'Expédition'], en: ['Reproduction:', 'Shipping:'], es: ['Reproducción:', 'Envío:'] };
  function formatFrom(desc) {
    var d = String(desc || '').replace(/<\/p>/g, ' </p>').replace(/<br\s*\/?>/g, ' ');
    var tmp = document.createElement('div');
    tmp.innerHTML = d;
    d = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
    var lb = LAB[LOC] || LAB.fr;
    if (d.indexOf(lb[0]) > -1) d = d.split(lb[0])[0]; else if (d.indexOf(lb[1]) > -1) d = d.split(lb[1])[0];
    d = d.replace(/\.\.\./g, '…').replace(/ \.\./g, '');
    var i = d.indexOf(':');
    if (i < 0) return '';
    return d.slice(i + 1).split('.')[0].trim();
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function reqKey(rq) {
    if (rq === 'cn' || rq === 'cj' || rq === 'cm' || rq === 'om' || rq === 'oj') return 'req_c';
    if (rq === 'p') return 'req_o';
    return 'req_' + rq;
  }

  /* ---------- Recherche ---------- */
  function initSearch(box) {
    var form = box.querySelector('[data-lck-sform]'), input = box.querySelector('[data-lck-q]'), sel = box.querySelector('[data-lck-b]');
    var res = box.querySelector('[data-lck-results]'), st = box.querySelector('[data-lck-status]'), list = box.querySelector('[data-lck-list]'), help = box.querySelector('[data-lck-help]');
    var src = box.getAttribute('data-src'), root = rootUrl(box), fixedBrand = box.getAttribute('data-brand') || '';
    var timer = null, seq = 0;
    if (!form || !input) return;
    function warm() { loadData(src).catch(function () {}); }
    input.addEventListener('focus', warm, { once: true });
    if (sel) sel.addEventListener('focus', warm, { once: true });
    if ('requestIdleCallback' in window) requestIdleCallback(function () { setTimeout(warm, 2500); });

    function brand() { return fixedBrand || (sel ? sel.value : ''); }
    function show(r, K) {
      res.hidden = false;
      st.textContent = r.status || '';
      if (r.brand != null && K.b[r.brand] && K.b[r.brand][1] && K.b[r.brand][1] !== fixedBrand) {
        var bn = K.b[r.brand][0], cnt = K.m.filter(function (m) { return m[1] === r.brand && !(m[3] === 1 && passeVar(m)); }).length;
        st.innerHTML = H(r.status || '') + ' <a class="lck-results__all" href="' + root + 'collections/' + encodeURIComponent(K.b[r.brand][1]) + '">' + H(T('see_all_models', { n: cnt, b: bn })) + '</a>';
      }
      help.hidden = !r.help;
      list.innerHTML = oneByProduct(r.list).map(function (x, i) {
        var e = x.r, b = brandOf(K, e)[0], pv = passeVar(e);
        var tag = e[3] === 1 ? '<em class="lck-tag">' + H(T('res_passe')) + '</em>' : e[3] === 2 ? '<em class="lck-tag">' + H(T('res_copie')) + '</em>' : pv && T('tag_passe_opt') ? '<em class="lck-tag lck-tag--soft">' + H(T('tag_passe_opt')) + '</em>' : '';
        var ok = x.ruleHit ? '<span class="lck-req lck-req--ok">' + H(T('res_recognized')) + '</span>' : '';
        return '<li class="lck-res' + (r.top && i === 0 ? ' lck-res--top' : '') + '"><a href="' + H(href(root, e)) + '" data-h="' + H(handle(e)) + '" data-t="' + e[3] + '" data-pv="' + (pv || '') + '">' +
          '<span class="lck-res__img"><img alt="" width="56" height="56" loading="lazy" hidden></span>' +
          '<span class="lck-res__main"><span class="lck-res__t">' + H(e[2]) + (tag ? ' ' + tag : '') + '</span>' +
          '<span class="lck-res__fmt" hidden></span>' +
          '<span class="lck-res__meta"><span class="lck-req lck-req--' + H(e[8]) + '">' + H(T(reqKey(e[8]))) + '</span>' + ok + '</span></span>' +
          '<span class="lck-res__p"><span data-p></span><small>' + H(T('res_choose')) + '</small></span></a></li>';
      }).join('');
      [].forEach.call(list.querySelectorAll('a[data-h]'), function (a) {
        var h = a.getAttribute('data-h');
        productJson(root, h).then(function (p) {
          if (!p) return;
          var im = a.querySelector('img'), t = a.querySelector('.lck-res__t'), f = a.querySelector('.lck-res__fmt'), pr = a.querySelector('[data-p]');
          if (p.featured_image && im) { im.src = imgUrl(p.featured_image, 112); im.hidden = false; }
          if (p.title && t) t.firstChild.nodeValue = p.title + ' ';
          /* Fiche avec clé de passe : prix de la variante du résultat ; le format affiché sur la fiche est celui de la clé simple */
          var pv = +a.getAttribute('data-pv') || 0, passe = a.getAttribute('data-t') === '1', vs = p.variants || [], v = null;
          if (pv) v = vs.filter(function (x) { return passe ? x.id === pv : x.id !== pv; })[0] || null;
          var fm = passe && pv ? '' : formatFrom(p.description);
          if (fm && f) { f.textContent = T('res_fmt') + ' ' + fm; f.hidden = false; }
          if (pr) pr.textContent = money(v ? v.price : p.price);
        });
      });
    }
    function run(force) {
      var v = input.value, my = ++seq;
      if (!force && N(v).length < 3) { if (!N(v)) { res.hidden = true; } return; }
      loadData(src).then(function (K) {
        if (my !== seq) return;
        var b = brand(), r = find(K, v, b);
        if (b && r.none) {
          var r2 = find(K, v, '');
          if (!r2.none && r2.list.length) {
            var bn = (K.b.filter(function (x) { return x[1] === b; })[0] || [''])[0];
            r2.status = T('st_brand_none', { b: bn }) + ' ' + r2.status;
            r = r2;
          }
        }
        show(r, K);
      }).catch(function () {
        res.hidden = false; st.textContent = T('load_err'); list.innerHTML = ''; help.hidden = false;
      });
    }
    input.addEventListener('input', function () {
      var p = input.selectionStart, v = input.value.toUpperCase();
      if (v !== input.value) { input.value = v; try { input.setSelectionRange(p, p); } catch (e) {} }
      clearTimeout(timer);
      timer = setTimeout(function () { run(false); }, 320);
    });
    if (sel) sel.addEventListener('change', function () { if (N(input.value)) run(true); });
    form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); run(true); });
    list.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-h]');
      if (!a) return;
      try { sessionStorage.setItem('lck-num', JSON.stringify({ h: a.getAttribute('data-h'), n: input.value.trim() })); } catch (err) {}
    });
  }

  /* ---------- Fiche clé ---------- */
  /* Type de clé (30/10/2026) : boutons radio « id » (data-lck-type 0 = clé simple, 1 = clé de passe) ; les éléments
     data-lck-t (prix, format, pièces, délai, précisions) ne s'affichent que pour le type choisi, et leurs champs ne
     sont envoyés que pour ce type. Nouvelle carte de propriété : si le client ne l'a plus et que la fiche en propose
     une (data-lck-card, prix fixé), elle est ajoutée au panier avec la clé, une seule fois par numéro de clé : d'office
     si le fabricant l'exige, sinon seulement si le client coche la case (data-lck-card-opt, 30/10/2026).
     Essai sans prix : ?lc16card=<identifiant de variante> dans l'adresse de la fiche. */
  var P_CARD = 'Pour la clé n°', P_KEY = 'Clé';
  function initProduct(sec) {
    var form = sec.querySelector('[data-lck-form]');
    if (!form) return;
    var scope = (sec.closest && sec.closest('.shopify-section')) || document;
    var h = sec.getAttribute('data-handle'), price = +sec.getAttribute('data-price') || 0, cfg = {};
    try { cfg = JSON.parse((scope.querySelector('[data-lck-cfg]') || document.querySelector('[data-lck-cfg]') || {}).textContent || '{}'); } catch (e) {}
    var num = form.querySelector('[data-lck-num]'), msg = form.querySelector('[data-lck-num-msg]');
    var qty = form.querySelector('[data-lck-qty-input]'), tot = form.querySelector('[data-lck-total]'), save = form.querySelector('[data-lck-save]');
    var cardl = form.querySelector('[data-lck-cardline]');
    var errs = form.querySelector('[data-lck-errors]'), btn = form.querySelector('[data-lck-submit]');
    var types = [].slice.call(form.querySelectorAll('input[data-lck-type]'));
    var root = rootUrl({ getAttribute: function () { return cfg.root; } });
    var testCard = (location.search.match(/[?&]lc16card=(\d+)/) || [])[1] || '';

    // Préremplissage depuis la recherche (même visite)
    try {
      var pre = JSON.parse(sessionStorage.getItem('lck-num') || 'null');
      if (pre && pre.h === h && pre.n && num && !num.value) num.value = String(pre.n).toUpperCase();
    } catch (e) {}

    function typeInput() { return types.filter(function (x) { return x.checked; })[0] || null; }
    function curT() { var r = typeInput(); return r ? r.getAttribute('data-lck-type') : ''; }
    function shown(el) { return !el.hidden && !(el.closest && el.closest('[hidden]')); }

    // Type de clé : n'affiche (et n'envoie) que ce qui concerne le type choisi
    function applyType(user) {
      var t = curT(), r = typeInput();
      if (t !== '') {
        [].forEach.call(scope.querySelectorAll('[data-lck-t]'), function (el) {
          var off = el.getAttribute('data-lck-t') !== t;
          el.hidden = off;
          if (/^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) el.disabled = off;
          [].forEach.call(el.querySelectorAll('input,select,textarea'), function (i) {
            i.disabled = off;
            var nm = i.getAttribute('data-lck-name');
            if (nm) i.name = off ? 'lck-x-' + el.getAttribute('data-lck-t') : nm;
          });
        });
        price = +r.getAttribute('data-price') || price;
        sec.setAttribute('data-price', price);
        if (user && window.history && history.replaceState) {
          try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        }
      }
      setCard();
      total();
      if (user) check();
    }
    types.forEach(function (r) { r.addEventListener('change', function () { applyType(true); }); });

    // Carte : j'ai / je n'ai plus (pour chaque partie « pièces », celle du type choisi seulement)
    function setCard() {
      [].forEach.call(form.querySelectorAll('[data-lck-cardset]'), function (cs) {
        var live = !(cs.closest && cs.closest('[data-lck-t][hidden]'));
        var r = cs.querySelector('input[data-lck-has]:checked'), has = !r || r.getAttribute('data-lck-has') === '1';
        var yes = cs.querySelector('[data-lck-yes]'), no = cs.querySelector('[data-lck-no]');
        if (yes) { yes.hidden = !has; [].forEach.call(yes.querySelectorAll('input'), function (i) { i.disabled = !live || !has; }); }
        if (no) { no.hidden = has; [].forEach.call(no.querySelectorAll('input'), function (i) { i.disabled = !live || has; }); }
      });
      cardLine();
    }
    [].forEach.call(form.querySelectorAll('input[data-lck-has]'), function (r) { r.addEventListener('change', setCard); });

    // Nouvelle carte à ajouter au panier (bloc « je n'ai plus la carte » affiché, carte proposée avec un prix) :
    // d'office si le fabricant l'exige, sinon seulement si la case « nouvelle carte » est cochée (data-lck-card-opt)
    function card() {
      var b = [].filter.call(form.querySelectorAll('[data-lck-no]'), shown)[0];
      if (!b) return null;
      var id = b.getAttribute('data-lck-card') || '', p = +b.getAttribute('data-lck-card-price') || 0;
      if (b.getAttribute('data-lck-card-opt') === '1') {
        var o = b.querySelector('input[data-lck-optcard]');
        if (!o || !o.checked) return null;
      }
      if (testCard) id = testCard;
      if (!id || !(p > 0 || testCard)) return null;
      return { id: +id, p: p, k: b.getAttribute('data-lck-card-k') || 'card_plus' };
    }
    [].forEach.call(form.querySelectorAll('input[data-lck-optcard]'), function (o) { o.addEventListener('change', cardLine); });
    function cardLine() {
      if (!cardl) return;
      var c = card();
      cardl.hidden = !(c && c.p > 0);
      cardl.textContent = c && c.p > 0 ? T(c.k, { p: money(c.p) }) : '';
    }

    // Fichiers
    [].forEach.call(form.querySelectorAll('[data-lck-file] input[type=file]'), function (f) {
      var lab = f.closest('[data-lck-file]'), nm = lab.querySelector('[data-lck-file-name]'), none = nm ? nm.textContent : '';
      f.addEventListener('change', function () {
        var file = f.files && f.files[0], bad = '';
        if (file) {
          var okType = /^image\//.test(file.type) || file.type === 'application/pdf' || /\.(jpe?g|png|heic|heif|webp|pdf)$/i.test(file.name);
          if (!okType) bad = T('err_type'); else if (file.size > 15 * 1024 * 1024) bad = T('err_size');
        }
        if (bad) { f.value = ''; if (nm) nm.textContent = bad; lab.classList.remove('is-set'); lab.classList.add('is-bad'); return; }
        lab.classList.remove('is-bad');
        lab.classList.toggle('is-set', !!file);
        if (nm) nm.textContent = file ? file.name : none;
      });
    });

    // Quantité, total et remise
    function q() { var v = parseInt(qty && qty.value, 10); return isNaN(v) || v < 1 ? 1 : Math.min(v, 50); }
    function total() {
      var n = q(), sub = price * n, rate = n >= 4 ? 10 : n >= 2 ? 5 : 0, d = Math.floor((sub * rate + 50) / 100);
      if (tot) tot.textContent = money(sub - d);
      if (save) { save.hidden = !rate; save.textContent = rate ? '−' + rate + ' % ' + T('save', { p: money(d) }) : ''; }
    }
    [].forEach.call(form.querySelectorAll('[data-lck-qty]'), function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(50, q() + (+b.getAttribute('data-lck-qty')))); total(); });
    });
    if (qty) { qty.addEventListener('input', total); qty.addEventListener('change', function () { qty.value = q(); total(); }); }

    // Contrôle du numéro (formats du modèle, selon le type de clé choisi)
    var K = null, rows = [], timer = null;
    function mine() {
      var t = curT();
      return rows.filter(function (r) { return t === '1' ? r[3] === 1 : t === '0' ? r[3] !== 1 : true; })[0] || null;
    }
    function sibling() {
      var t = curT();
      if (t === '') return null;
      return rows.filter(function (r) { return t === '1' ? r[3] !== 1 : r[3] === 1; })[0] || null;
    }
    function check() {
      if (!num || !msg) return;
      var v = N(num.value), me = mine();
      msg.className = 'lck-msg';
      msg.textContent = '';
      if (!K || !me || v.length < 3 || !me[7]) return;
      var mh = ruleHit(me, v), sib = sibling(), sh = sib && sib[7] ? ruleHit(sib, v) : null;
      /* Numéro au format des deux types : le format le plus précis l'emporte (ex. Vachette « S1… » ou « 123P… » : clé de passe) */
      if (mh.hit && !(sh && sh.hit && sh.q > mh.q)) { msg.className = 'lck-msg lck-msg--ok'; msg.textContent = T('num_ok'); return; }
      if (sh && sh.hit) {
        var toPasse = sib[3] === 1;
        msg.className = 'lck-msg lck-msg--warn';
        msg.innerHTML = H(T(toPasse ? 'num_is_passe' : 'num_is_simple')) + ' <button type="button" class="lck-linkbtn" data-lck-switch="' + (toPasse ? '1' : '0') + '">' + H(T(toPasse ? 'type_switch_1' : 'type_switch_0')) + '</button>';
        return;
      }
      var r = match(K, v, '');
      if (r.top && rows.indexOf(r.top.r) < 0 && r.top.ruleHit) {
        var o = r.top.r;
        msg.className = 'lck-msg lck-msg--warn';
        msg.innerHTML = H(T('num_other')) + ' <a href="' + H(href(root, o)) + '">' + H(o[2]) + (o[3] === 1 ? ' (' + H(T('res_passe')) + ')' : '') + '</a>';
        try { sessionStorage.setItem('lck-num', JSON.stringify({ h: handle(o), n: num.value.trim() })); } catch (e) {}
        return;
      }
      msg.className = 'lck-msg lck-msg--warn';
      msg.textContent = T('num_check');
    }
    if (msg) msg.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lck-switch]');
      if (!b) return;
      var t = b.getAttribute('data-lck-switch'), r = types.filter(function (x) { return x.getAttribute('data-lck-type') === t; })[0];
      if (r) { r.checked = true; applyType(true); r.focus({ preventScroll: true }); }
    });
    if (num) {
      num.addEventListener('input', function () {
        var p = num.selectionStart, v = num.value.toUpperCase();
        if (v !== num.value) { num.value = v; try { num.setSelectionRange(p, p); } catch (e) {} }
        num.removeAttribute('aria-invalid');
        clearTimeout(timer);
        timer = setTimeout(check, 350);
      });
      var go = function () {
        if (!cfg.src) return;
        loadData(cfg.src).then(function (D) {
          K = D;
          rows = D.m.filter(function (r) { return handle(r) === h; });
          check();
        }).catch(function () {});
      };
      if (num.value) go(); else if ('requestIdleCallback' in window) requestIdleCallback(go); else setTimeout(go, 1500);
      num.addEventListener('focus', go, { once: true });
    }

    applyType(false);

    // Ajout de la nouvelle carte (une fois par numéro de clé : on regarde d'abord le panier)
    function addCard(c, n0) {
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var dup = (cart.items || []).some(function (it) { return it.variant_id === c.id && it.properties && N(it.properties[P_CARD]) === N(n0); });
          if (dup) return null;
          var t = curT(), props = {};
          props[P_CARD] = n0;
          props[P_KEY] = (cfg.title || '') + (t !== '' && cfg.types ? ' – ' + cfg.types[+t] : '');
          return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify({ items: [{ id: c.id, quantity: 1, properties: props }] }) });
        });
    }

    // Validation à l'envoi
    function visible(el) { return !el.disabled && !(el.closest('[hidden]')); }
    var sending = false;
    form.addEventListener('submit', function (e) {
      var list = [], first = null;
      function bad(el, k) { list.push(T(k)); if (el) { el.setAttribute('aria-invalid', 'true'); if (!first) first = el; } }
      [].forEach.call(form.querySelectorAll('[aria-invalid]'), function (el) { el.removeAttribute('aria-invalid'); });
      if (num && num.required && !N(num.value)) bad(num, 'err_num');
      [].forEach.call(form.querySelectorAll('input[name="properties[N° de carte de propriété]"]'), function (cn) {
        if (visible(cn) && cn.required && !N(cn.value)) bad(cn, 'err_cardno');
      });
      [].forEach.call(form.querySelectorAll('input[type=file][required]'), function (f) {
        if (visible(f) && !(f.files && f.files.length)) bad(f, /clé\]$/.test(f.name) ? 'err_keyphoto' : 'err_photo');
      });
      var tel = form.querySelector('input[type=tel]');
      if (tel && tel.required && (tel.value.replace(/\D/g, '').length < 9)) bad(tel, 'err_tel');
      var cert = form.querySelector('input[type=checkbox][required]');
      if (cert && !cert.checked) bad(cert, 'err_cert');
      if (list.length) {
        e.preventDefault();
        errs.innerHTML = list.map(H).join('<br>');
        errs.hidden = false;
        if (first) { first.focus({ preventScroll: true }); (first.closest('.lck-field') || first).scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      errs.hidden = true;
      if (qty) qty.value = q();
      if (btn) { btn.disabled = true; var sp = btn.querySelector('span'); if (sp) sp.textContent = T('adding'); }
      var c = card();
      if (!c || sending) return;
      // Nouvelle carte : ajoutée d'abord (requête au panier), puis la clé par l'envoi normal du formulaire (fichiers compris)
      e.preventDefault();
      sending = true;
      var done = function () { sending = false; HTMLFormElement.prototype.submit.call(form); };
      addCard(c, num ? num.value.trim() : '').then(done, done);
    });
    window.addEventListener('pageshow', function () {
      sending = false;
      if (btn) { btn.disabled = false; var sp = btn.querySelector('span'); if (sp && btn.getAttribute('data-label')) sp.textContent = btn.getAttribute('data-label'); }
    });
    if (btn) { var sp0 = btn.querySelector('span'); if (sp0) btn.setAttribute('data-label', sp0.textContent); }
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-lck-search]'), initSearch);
    [].forEach.call(document.querySelectorAll('[data-lck-product]'), initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();